import Facebook from '@/assets/socialMedia/Facebook.svg?react'
import Instagram from '@/assets/socialMedia/Instagram.svg?react'
import LinkedIn from '@/assets/socialMedia/LinkedIn.svg?react'
import Pinterest from '@/assets/socialMedia/Pinterest.svg?react'
import Reddit from '@/assets/socialMedia/Reddit.svg?react'
import TikTok from '@/assets/socialMedia/TikTok.svg?react'
import X from '@/assets/socialMedia/X.svg?react'
import type { socialMediaSheetSchemaType } from '@/utils/schemas'

export const SOCIAL_PLATFORMS: ReadonlyArray<{
  key: keyof socialMediaSheetSchemaType
  Icon: React.FC<React.SVGProps<SVGSVGElement>>
}> = [
  { key: 'instagram', Icon: Instagram },
  { key: 'x', Icon: X },
  { key: 'linkedIn', Icon: LinkedIn },
  { key: 'reddit', Icon: Reddit },
  { key: 'tikTok', Icon: TikTok },
  { key: 'facebook', Icon: Facebook },
  { key: 'pinterest', Icon: Pinterest },
]
